import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, SimpleChanges, OnChanges,LOCALE_ID, Inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthSevices, ClientService, CouponService, OmniSearchService, ToastMessageService } from '@fitness-force/api';
import { ClientReferralStatus, ElasticProviderName } from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/errors';
import { NoComponentComponent, NoOfferComponent } from '@fitness-force/grid';
import { AddCouponWithClient, CLientReferral, ClientById, ClientCoupon, ClientInteraction, OfferMaster, OmniSearchResponse, STAFFINTERFACE } from '@fitness-force/models';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';
import { ClientInteractionTabComponent } from 'libs/shared/src/lib/components/client-profile/client-interaction-tab/client-interaction-tab.component';
import { RouteStateService } from 'libs/shared/src/lib/router-guard/route-state-service.service';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';

import { DialogModule } from 'primeng/dialog';

import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'client-overview-tab',
  templateUrl: './client-overview-tab.component.html',
  styleUrls: ['./client-overview-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [    CommonModule,
    ButtonModule,
    FormsModule,
    PopoverModule,
    CheckboxModule,
    SkeletonModule,
    StyleClassModule,
    
    ChipModule,
    DateTimeFormatPipe,
    DialogModule,
    TableModule,
    ClientInteractionTabComponent,
    AvatarModule,
    ShortNamePipe,
    TranslateModule
  ]
})
export class ClientOverviewTabComponent implements OnInit,OnChanges, OnDestroy {
  @Input('clientDetails') client: ClientById = {} as ClientById;
  @Input('showSkeleton') showSkeleton$ = new BehaviorSubject<boolean>(true);
  @Input('interactions') clientInteractions$ = new BehaviorSubject<ClientInteraction[]>([]);
  @Input('clientId') clientId: number = 0;
  @Input('tenantId') tenantId: number = 0;
  @Input('clickFromTab') clickfromTab = new BehaviorSubject<boolean>(false);
  @Input('clientReferrals') clientReferrals$ = new BehaviorSubject<CLientReferral[]>([]);
  @Input('clientOffers') clientOffers$ = new BehaviorSubject<ClientCoupon[]>([]);
  @Input('height') height = "44vh";
  @Input('interactionId') interactionId: number =0;

  @Output() changeTab : EventEmitter<{changeTab: boolean, tabName:string}> = new EventEmitter();
  @Output() reloadData : EventEmitter<{relaodData: boolean}> = new EventEmitter();

  promotionPreferenceMap = new Map();
  showCollapsed$ = new BehaviorSubject<boolean>(true);
  showTextbox:boolean=false;
  clientNotes:string | null="";
  staffInfo:BehaviorSubject<any> = new BehaviorSubject<any>(null);
  staffList:any;
  clientReferrals:any;
  currentUserDetails: any;
  parentClient:ClientById ={} as ClientById;
  loadingEmail: boolean = false;
  loadingSMS: boolean = false;
  loadingWhatsApp: boolean = false;
  showEligibleOffers: boolean = false;
  addOfferModal:boolean=false;

  loading = new BehaviorSubject<boolean>(false);
  column!: any;
  emptyStateComponent$ = new BehaviorSubject<any>(NoOfferComponent);
  tableData = new BehaviorSubject<OfferMaster[]>([]);
  columns: any = new BehaviorSubject([]);
  selectAll = new BehaviorSubject(false);
  referredByClient: any;
  showClientSidebar: boolean = false;


  constructor(public cd:ChangeDetectorRef, 
     public clientService:ClientService, 
     private toastService:ToastMessageService,
     private translateService:TranslateService,
     private authService: AuthSevices,
     private couponService: CouponService,
     public translate: TranslateService,
     public store:Store,
     @Inject(LOCALE_ID) public locale: string,
     private omniSearchService: OmniSearchService,
     private routerStateService : RouteStateService,
     private staffStoreService: StaffStoreService
    ) { }

  ngOnInit(): void {
    this.staffStoreService.getAllStaff(this.tenantId).subscribe((res: STAFFINTERFACE[]) => {
      this.staffList = res;
      this.currentUserDetails = this.authService.currentUserDetails();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the selectedOption input
    if (changes['client'] && changes['client'].currentValue != changes['client'].previousValue) {
      if(this.client && this.client.referred_by && this.client.referred_by != 0)
         this.searchClientInomniSearch(this.client.referred_by.toString());
      if(this.client && this.client.is_child)
         this.getParentClient();
    }
}

  getParentClient()
  {
    this.clientService.getClientByIdNew(this.client.parent_client_id).subscribe({
      next: (res: ClientById) => {
        this.parentClient = res;
        this.cd.detectChanges();
      },
      error: (error: any) => {
        this.cd.detectChanges();
      }
    });
  }

  get showSkeleton(): boolean {
    return this.showSkeleton$.value;
  }

  saveNotes()
  {
    let clientObj: Array<{ op: string, path: string, value: any }> = [];
    clientObj.push({ op: "replace", path: "/Note", value: this.clientNotes });
    this.clientService.patchClient(this.client.id,this.tenantId, clientObj)
    .subscribe({
      next: (data: any) => {
        this.client.note = this.clientNotes!;
        this.client.note_updated_date = new Date().toISOString();
        this.client.note_updated_by = this.currentUserDetails.Id;
        this.showTextbox = false;
        this.translateService.get('CLIENT_PROFILE.NOTES_ADDED')
        .subscribe((translation) => {
         this.toastService.showSuccess(translation);
        });
        this.cd.detectChanges();
      },
      error: (error: AppErrors) => {
        this.showTextbox = false;
        this.toastService.showError(error);
        this.cd.detectChanges();
      },
    });
  }

  deleteNotes()
  {
    this.clientNotes=null;
    let clientObj: Array<{ op: string, path: string, value: any }> = [];
    clientObj.push({ op: "replace", path: "/Note", value: this.clientNotes });
    this.clientService.patchClient(this.client.id,this.tenantId, clientObj)
    .subscribe({
      next: (data: any) => {
        this.client.note = null;
        this.client.note_updated_date = new Date().toISOString();
        this.client.note_updated_by = this.currentUserDetails.Id;
        this.showTextbox = false;
        this.translateService.get('CLIENT_PROFILE.NOTES_DELTE')
        .subscribe((translation) => {
         this.toastService.showSuccess(translation);
        });
        this.cd.detectChanges();
      },
      error: (error: AppErrors) => {
        this.showTextbox = false;
        this.toastService.showError(error);
        this.cd.detectChanges();
      },
    });
  }


  changeTabClick()
  {
    this.changeTab.emit({changeTab:true, tabName:"ACTIVITY_FEED"})
  }

  getStaffDetails(staffId:number)
  {
    return this.staffList.find((o: { id: number; }) => o.id == staffId);
  }

  getOpenReferrals()
  {
    let data = this.clientReferrals$.value;
    return data.filter(o => o.status == ClientReferralStatus.Active || o.status.toString() == ClientReferralStatus[ClientReferralStatus.Active]);
  }

  getSuccessfullReferrals()
  {
    let data = this.clientReferrals$.value;
    return data.filter(o => o.status == ClientReferralStatus.Successful || o.status.toString() == ClientReferralStatus[ClientReferralStatus.Successful]);
  }

  showOffer()
  {
    this.addOfferModal= true;
    this.getOfferList();
  }

  getOfferList() {
    this.loading.next(true);
    this.couponService.getCoupons(this.tenantId)
      .subscribe({
        next: (response: any) => {
          this.loading.next(false);
          let offers: OfferMaster[] = [] as OfferMaster[];
          if (response && response.items) {
            offers= response.items;
            this.tableData.next(offers);
          } else {
            this.tableData.next([]);
            this.emptyStateComponent$.next(NoComponentComponent);
          }
        },
        error: (error: any) => {
          this.tableData.next([]);
          this.loading.next(false);
        },
      });
  }

  isOfferAdded(id:number)
  {
    return this.clientOffers$.value.find(o => o.id == id);
  }

  AddCouponToClient(offer: OfferMaster) {
    let clientIds: any[] = [];
    clientIds.push(this.client.id);
    let addClientToCoupon: AddCouponWithClient = {} as AddCouponWithClient;
    addClientToCoupon.client_ids = clientIds;
    this.couponService.AddEligibleClients(this.tenantId, offer.id, addClientToCoupon).subscribe({
      next: (response: any) => {
        this.translate.get('ADMIN.COUPON.ERRORS.CLIENt_ADDED')
          .subscribe((translation) => {
            this.toastService.showSuccess(translation)
          });
          this.cd.detectChanges();
          this.reloadData.emit({relaodData:true})
      },
      error: (error: any) => {
        this.translate.get('ADMIN.COUPON.ERRORS.CLIENt_ADDED_ERROR')
          .subscribe((translation) => {
            this.toastService.showError(error)
          });
          this.cd.detectChanges();
      },
    });
  }

  RemoveCouponToClient(offer: OfferMaster) {
    this.couponService.RemoveEligibleClients(this.tenantId, offer.id, this.client.id).subscribe({
      next: (response: any) => {
        this.translate.get('ADMIN.COUPON.ERRORS.CLIENt_REMOVED')
          .subscribe((translation) => {
            this.toastService.showSuccess(translation)
          });
          this.cd.detectChanges();
          this.reloadData.emit({relaodData:true})
      },
      error: (error: any) => {
        this.translate.get('ADMIN.COUPON.ERRORS.CLIENt_REMOVED_ERROR')
          .subscribe((translation) => {
            this.toastService.showError(error)
          });
          this.cd.detectChanges();
      },
    });
  }

  searchClientInomniSearch(value:string)
  {
    const request = {
      language: this.locale,
      query: value,
      providers: [{
        provider_name: ElasticProviderName.Clients,
        pagination: { page_number: 0, page_size: 10 }
      }]
    };

    this.omniSearchService.Search(request).subscribe({
      next: (response: OmniSearchResponse) => {
        const clients = response.searchResults.clients.items;
        this.referredByClient = clients.find(o => o.clt_id == this.client.referred_by);
        this.cd.detectChanges();
      },
      error(msg) {
      }
    });
  }

  closeSidebar(clientId:number)
  {
    this.routerStateService.setClientSidebarById(clientId);
    this.routerStateService.closeClientSidebar(true);
  }

  ngOnDestroy(): void {
    // Only complete BehaviorSubjects created in this component, not the ones passed as inputs
    if (this.showCollapsed$) {
      this.showCollapsed$.complete();
    }
    if (this.staffInfo) {
      this.staffInfo.complete();
    }
    if (this.loading) {
      this.loading.complete();
    }
    if (this.emptyStateComponent$) {
      this.emptyStateComponent$.complete();
    }
    if (this.tableData) {
      this.tableData.complete();
    }
    if (this.columns) {
      this.columns.complete();
    }
    if (this.selectAll) {
      this.selectAll.complete();
    }
    
    // Clear other resources
    this.promotionPreferenceMap.clear();
  }

}